import { useSnackbar } from "notistack";
import React, { useCallback, useEffect, useState } from "react";

import { UserSession, useSession } from "0.Mine/2.Context/sessionContext";
import axiosInstance from "0.Mine/axiosInstance";

import { useQlickupAPI } from "../APICall";

export const UseSignInWithCredentials = () => {
  const { updateSession } = useSession();
  const [error, setError] = useState<string>();
  const { enqueueSnackbar } = useSnackbar(); // Add snackbar hook

  const signinWithCredentials = async (
    email: string,
    password: string,
    confirmPassword: string
  ) => {
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      enqueueSnackbar("Passwords do not match", { variant: "error" });
      return;
    }
    try {
      const response = await axiosInstance.post(`POST/login.php`, { email, password });
      console.log(response);

      const userSession: UserSession = {
        user: {
          id: response.data.user_info.id,
          name: response.data.user_info.name,
          email: response.data.user_info.email,
          image: response.data.user_info.profile_pic,
          token: response.data.user_info.token,
          subscriptionExpiry: response.data.user_info.subscription_expiry,
          subscriptionTier: response.data.user_info.subcription_tier,
          tokenExpiry: response.data.user_info.token_expiry,
          trialExpiry: response.data.user_info.trial_expiry,
          onboarding: response.data.user_info.onboarding,
          qlickup: response.data.user_info.qlickup,
          businessid: response.data.user_info.businessid,
          permissions: response.data.user_info.permissions,
        },
      };

      updateSession(userSession);
      enqueueSnackbar(`Welcome back, ${userSession.user.name}!`, { variant: "success" });
      console.log(userSession);
    } catch (error) {
      console.log(
        "error signing in with credentials",
        error.response?.data?.error || error.message
      );
      const errorMessage = error.response?.data?.error || "Error signing in with credentials";
      setError(errorMessage);
      enqueueSnackbar(errorMessage, { variant: "error" });
      return;
    }
  };

  return { signinWithCredentials, error };
};

export const useSignInWithGoogle = () => {
  const { updateSession } = useSession();
  const [token, setToken] = useState<string | null>(null);
  const { enqueueSnackbar } = useSnackbar(); // Add snackbar hook

  // Function to check URL for token and process authentication
  const processAuthToken = useCallback(async () => {
    const searchParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = searchParams.get("token");

    if (tokenFromUrl) {
      setToken(tokenFromUrl);
      // Clean URL by removing token parameter
      window.history.replaceState({}, document.title, window.location.pathname);

      try {
        const response = await axiosInstance.get(`GET/user.php?token=${tokenFromUrl}`);
        if (response.data.success) {
          const userData = {
            user: {
              id: response.data.user.id,
              name: response.data.user.name,
              email: response.data.user.email,
              image: response.data.user.profile_pic,
              token: tokenFromUrl,
              subscriptionExpiry: response.data.user.subscription_expiry,
              subscriptionTier: response.data.user.subcription_tier,
              tokenExpiry: response.data.user.token_expiry,
              trialExpiry: response.data.user.trial_expiry,
              onboarding: response.data.user.onboarding,
              qlickup: response.data.user.qlickup,
            },
          } as UserSession;

          updateSession(userData);
          enqueueSnackbar(`Welcome, ${userData.user.name}!`, { variant: "success" });
        } else {
          console.log("User not signed in successfully!");
          enqueueSnackbar("Login failed. Please try again.", { variant: "error" });
        }
      } catch (error) {
        console.error("Error during sign in:", error);
        enqueueSnackbar("Error during sign in. Please try again.", { variant: "error" });
      }
    } else {
      const errorMsg = searchParams.get("error");
      console.log(errorMsg);
      if (errorMsg === "noauth") {
        enqueueSnackbar("Your subscription has expired.", { variant: "warning" });
        window.location.href = "/subscription";
      }
    }
  }, [updateSession, enqueueSnackbar]);

  // Process token on component mount
  useEffect(() => {
    processAuthToken();
  }, [processAuthToken]);

  // Function called when the user clicks the "Sign in with Google" button
  const signInWithGoogle = useCallback(() => {
    window.location.href = "https://ordata.link1studios.com/CMS/V1/auth/google.php?auth_url=true";
  }, []);

  return { signInWithGoogle, token };
};

export const signinWithFacebook = async () => {
  return {
    success: true,
    user: "Alex",
    error: null,
  };
};
